import axios from "../index";

const getData = query => {
    return axios.get(`school${query}`)
}
const getDataById = (id, query) => {
    return axios.get(`school/${id}${query}`)
}

export default {getData, getDataById}